import type { AnimationProps } from 'framer-motion';

/**
 * Default transition for all animated items
 */
export const transition: AnimationProps['transition'] = {
  ease: 'easeIn',
  duration: 0.15,
};

const loading = {
  opacity: 0,
};

export const DEFAULT_VARIANTS_SIDEBAR_NAVIGATION: AnimationProps['variants'] = {
  collapsed: {
    width: 2,
    opacity: 1,
    transition,
  },
  expanded: {
    opacity: 1,
    width: 5,
    transition,
  },
  loading,
};

export const DEFAULT_VARIANTS_ASSET_VIEWER: AnimationProps['variants'] = {
  collapsed: {
    opacity: 1,
    width: 2,
    x: 11,
    transition,
  },
  expanded: {
    opacity: 1,
    width: 5,
    x: 9.5,
    transition,
  },
  loading,
};

export const DEFAULT_VARIANTS_COMMENTS: AnimationProps['variants'] = {
  collapsed: {
    opacity: 1,
    width: 2,
    x: 15,
    transition,
  },
  expanded: {
    opacity: 1,
    width: 5,
    x: 12,
    transition,
  },
  loading,
};

export const DEFAULT_VARIANTS_TIMELINE: AnimationProps['variants'] = {
  collapsed: {
    opacity: 1,
    height: 2,
    y: 15,
    transition,
  },
  expanded: {
    opacity: 1,
    height: 5,
    y: 12,
    transition,
  },
  loading,
};
export const DEFAULT_VARIANTS_DEFAULT_ROW: AnimationProps['variants'] = {
  collapsed: {
    opacity: 1,
    height: 2,
    y: 7,
    transition,
  },
  expanded: {
    opacity: 1,
    height: 5,
    y: 7,
    transition,
  },
  loading,
};
